<template>
  <default-layout />
</template>

<script setup lang="ts">
  import DefaultLayout from '@/layouts/default.vue'
</script>
